export default __webpack_public_path__ + "static/media/custom.0ad457ab.webp";